/**
 * useProjectMetadata Hook
 * Extracted from MultiProjectContext.tsx
 * Handles project metadata retrieval (color, info)
 */

import { useCallback } from 'react';
import { getProjectColor } from '../utils/projectUtils';
import type { ProjectDataWithMeta } from '../types/multiProject';
import type { ProjectInfo } from '@/features/projects/services/projectService';

interface UseProjectMetadataParams {
  projectsData: Map<string, ProjectDataWithMeta>;
  availableProjects: ProjectInfo[];
}

export function useProjectMetadata({
  projectsData,
  availableProjects
}: UseProjectMetadataParams) {

  const getProjectColorMemo = useCallback((projectId: string) => {
    const project = projectsData.get(projectId);
    return project?.color || getProjectColor(projectId);
  }, [projectsData]);

  const getProjectInfo = useCallback((projectId: string) => {
    return availableProjects.find(p => p.projectId === projectId);
  }, [availableProjects]);

  return {
    getProjectColor: getProjectColorMemo,
    getProjectInfo
  };
}
